import { CustomerModel } from "../../data/entities";
import { CustomerODataRepo, CustomerRepo } from "../../data/repo/organization";
import { BaseEntityService } from "../BaseEntityService";

export class CustomerService extends BaseEntityService<CustomerModel, CustomerRepo, CustomerODataRepo> {
  constructor() {
    super(new CustomerRepo(), new CustomerODataRepo());
  }

  async searchAsync(query: string): Promise<CustomerModel[]> {
    return await this.repo.searchAsync(query);
  }
}

export default CustomerService;
